const staticUrl = (path: string): string =>
  `${process.env.PUBLIC_URL}/data/${path}`

const failedToLoad = (url: string, response: Response): Error =>
  new Error(`Failed to load ${url}: ${response.status} ${response.statusText}`)

const isJson = (response: Response): boolean =>
  (response.headers.get('content-type') ?? '').includes('application/json')

export const fetchStaticJson = async <T>(path: string): Promise<T> => {
  const url = staticUrl(path)
  const response = await fetch(url)
  if (!response.ok) {
    throw failedToLoad(url, response)
  }
  return response.json()
}

/**
 * Like fetchStaticJson, but a missing file resolves to null. The hosts
 * answer a missing path with the SPA index.html (200 text/html), so a
 * response that is not JSON counts as missing too.
 */
export const fetchOptionalStaticJson = async <T>(
  path: string
): Promise<T | null> => {
  const url = staticUrl(path)
  const response = await fetch(url)
  if (response.status === 404) {
    return null
  }
  if (!response.ok) {
    throw failedToLoad(url, response)
  }
  if (!isJson(response)) {
    return null
  }
  return response.json()
}
